import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const Confine = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='system confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-confine-fr.png`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Marona peut <span className='text-pborange'>combiner ses alliés fantômes</span> avec{' '}
                        <span className='text-pborange'>
                            des bouts de bois, des roches ou des objets présents sur la carte
                        </span>{' '}
                        via ses pouvoirs pendant un combat.
                    </p>
                    <p className='mt-8'>
                        En effectuant un Combinage avec une roche, la défense du personnage augmentera mais sa vitesse
                        diminuera. Avec une arme en revanche, sa puissance d’attaque sera renforcée. Bref,{' '}
                        <span className='text-pborange'>suivant la cible du Combinage</span>, vos personnages pourront
                        bénéficier de diverses caractéristiques propres à la situation.
                    </p>{' '}
                    <div className='flex mt-8'>
                        <div className='w-full md:w-3/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confine', 1)
                                }}
                                className='ss-thumb'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confine-1-s.webp`}
                            />
                        </div>
                    </div>{' '}
                </div>{' '}
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='screen shot of game scene'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-system-fr.png`}
                    />
                </div>{' '}
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        <span className='text-pborange'>
                            Le Combinage s'estompe au bout d'un certain nombre de tours{' '}
                        </span>{' '}
                        (=RESTE). Une fois celui-ci terminé, le personnage ne peut plus se combiner à nouveau pendant le
                        combat, faites donc bien attention au timing d'utilisation.
                    </p>{' '}
                    <div className='flex mt-8'>
                        <div className='w-4/5 md:w-3/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confine', 2)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game scene'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confine-2-s.webp`}
                            />
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                Attention également à ne pas les combiner et les faire disparaître juste avant qu’ils
                                atteignent leur cible... !
                            </p>
                        </div>
                    </div>{' '}
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sm md:text-base text-shadow-white w-4/5 mx-auto mt-12'>
                    <p>
                        Vous pouvez vous combiner aux endroits que vous désirez : éloignés ou proches de Marona, quand
                        vous voulez, où vous voulez, avec qui ou quoi vous voulez !
                    </p>
                </div>
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={2}
                />
            </section>
        </>
    )
}
